import { $color_grey_5, $color_grey_9 } from '../pebbleGlobalToken/color.js';

/**
 * 单选框-颜色-info类型-边框
 * @description enDesc: -
 * @description type: Shadow
 * @description value: $color-grey-5
 */
var $radio_color_info_border = $color_grey_5;

/**
 * 单选框-颜色-边框
 * @description enDesc: -
 * @description type: Shadow
 * @description value: $color-grey-5
 */
var $radio_color_border = $color_grey_5;
/**
 * 单选框-颜色-主题颜色
 * @description enDesc: -
 * @description type: Shadow
 * @description value: $color-grey-9
 */
var $radio_color_primary = $color_grey_9;

/**
 * 单选框-颜色-主题 禁用颜色
 * @description enDesc: -
 * @description type: Shadow
 * @description value: $color-grey-5
 */
var $radio_color_primary_disabled = $color_grey_5;

export { $radio_color_border, $radio_color_info_border, $radio_color_primary, $radio_color_primary_disabled };
